module.exports = __webpack_public_path__ + "img/haus.5ca420e7.webp";